<div class="version-pill">
  {{ label }}
</div>
